// Module
var code = `<h3>Данные за выбранный период</h3>
<br>
<p>Название цепочки: {{ data[0].title }}</p>
<p>Кол-во людей получивших цепочку офферов: {{ data[0].activate_count }}</p>
<p>Кол-во людей завершивших цепочку офферов: {{ data[0].finish_count }}</p>
<p>Доход с цепочки на игрока: {{ data[0].avg_income_per_player }} \$</p>
<p ng-repeat="record in data">
    <span>Процент людей собравших награду {{ record.step_number }}-го оффера: {{ record.use_percentage }} %</span>
</p>
`;
// Exports
module.exports = code;